import { render } from "./ConnectionFailedPage.vue?vue&type=template&id=c08d84dc&scoped=true"
import script from "./ConnectionFailedPage.vue?vue&type=script&lang=js"
export * from "./ConnectionFailedPage.vue?vue&type=script&lang=js"

import "./ConnectionFailedPage.vue?vue&type=style&index=0&id=c08d84dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c08d84dc"]])

export default __exports__